import { css, mixins, styled } from '@bob/library'
import { Asset } from '@websrc/App/Components/Asset/Asset'

export const QuoteAsset = styled(Asset)`
  display: flex;
  align-items: center;
  min-height: 100px;
  width: 100%;
  height: 100%;
`

export type QuoteProps = {
  hasAsset: boolean
  reversedLayout?: boolean
}
export const QuoteContent = styled.div<QuoteProps>`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  align-content: center;
  justify-content: center;
  text-align: center;
  margin: auto;
  width: 100%;
  height: 100%;

  ${({ reversedLayout }) => (reversedLayout ? mixins.margin.bottom(0) : mixins.margin.bottom(30))};

  ${mixins.media.min.desktop} {
    justify-content: ${({ hasAsset }) => `${hasAsset ? 'start' : 'center'}`};
    text-align: ${({ hasAsset }) => `${hasAsset ? 'left' : 'center'}`};
  }
`
export const QuoteText = styled.div<QuoteProps>`
  width: 100%;
  & p {
    ${({ hasAsset }) => css`
      ${hasAsset
        ? `
      ${mixins.typography.headlineMedium};
      ${mixins.margin.bottom(10)};
      `
        : `
        ${mixins.typography.headlineLarge};
        ${mixins.margin.bottom(25)};
        `}
    `};
  }
`
export const QuoteSource = styled.div`
  width: 100%;
  & p {
    font-weight: 400;
    color: ${mixins.colors.grayDark};
  }
`
export type LearnMoreButtonWrapperProps = {
  isSibling?: boolean
}
export const LearnMoreButtonWrapper = styled.div<LearnMoreButtonWrapperProps>`
  width: 100%;
  ${({ isSibling }) => isSibling && mixins.margin.top(15)}
`
